<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-user-solid title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-stats">
          <div class="stat-item">
            <span class="stat-label">总记录数</span>
            <span class="stat-value">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-search"></i>
        <span>筛选条件</span>
      </div>
      <el-form ref="form" inline :model="searchData" label-width="90px">
        <el-form-item label="姓名">
          <el-input 
            v-model="searchData.memberName" 
            size="small" 
            placeholder="请输入姓名" 
            prefix-icon="el-icon-user"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input 
            v-model="searchData.mobile" 
            size="small" 
            placeholder="请输入手机号" 
            prefix-icon="el-icon-phone"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input 
            v-model="searchData.identityNo" 
            size="small" 
            placeholder="请输入身份证号" 
            prefix-icon="el-icon-postcard"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            style="width:280px;"
            size="small"
            v-model="searchData.timeSlot"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            prefix-icon="el-icon-date"
            unlink-panels
            clearable
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            size="small" 
            icon="el-icon-search" 
            @click="getList()"
            class="search-btn"
          >搜索</el-button>
          <el-button 
            type="info" 
            size="small" 
            icon="el-icon-refresh" 
            @click="reset"
            class="reset-btn"
          >重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-s-grid"></i>
        <span>用户列表</span>
      </div>
      <tp-table
        :tableData="list"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
      />
    </el-card>

    <!-- 订单备注 -->
    <OrderRemark
      v-if="showAddOrEdit"
      :rowId="rowId"
      :showAddOrEdit="showAddOrEdit"
      @closeDialog="closeDialogFun"
    />
  </div>
</template>

<script>
import { getListAPI, addRosterAPI } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import OrderRemark from "../order-remark/list.vue";

const columns = [
  {
    label: 'ID',
    prop: 'id',
    minWidth: '100',
    customRender(h, row) {
      return <p class="table-cell-text">{row['id'] || '-'}</p>
    }
  },
  {
    label: '姓名',
    prop: 'memberName',
    minWidth: '120',
    customRender(h, row) {
      return <p class="table-cell-text member-name">{row['memberName'] || '-'}</p>
    }
  },
  {
    label: '手机号',
    prop: 'mobile',
    minWidth: '130',
    customRender(h, row) {
      return <p class="table-cell-text">{row['mobile'] || '-'}</p>
    }
  },
  {
    label: '身份证号',
    prop: 'identityNo',
    minWidth: '180',
    customRender(h, row) {
      return <p class="table-cell-text">{row['identityNo'] || '-'}</p>
    }
  },
  {
    label: '性别',
    prop: 'genderName',
    minWidth: '90',
    customRender(h, row) {
      return <p class="table-cell-text">{row['genderName'] || '-'}</p>
    }
  },
  {
    label: '出生日期',
    prop: 'birthDay',
    minWidth: '120',
    customRender(h, row) {
      return <p class="table-cell-text">{row['birthDay'] || '-'}</p>
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '100',
    align: 'center',
    customRender(h, row) {
      return (
        <div style="display: flex; align-items: center; justify-content: center;">
          <el-tag 
            v-show={row['status'] == 1} 
            type="success" 
            size="small"
            effect="dark"
            class="status-tag"
          >正常</el-tag>
          <el-tag 
            v-show={row['status'] == 2} 
            type="danger" 
            size="small"
            effect="dark"
            class="status-tag"
          >注销</el-tag>
        </div>
      )
    }
  },
  {
    label: '创建时间',
    prop: 'createTime',
    minWidth: '180',
    customRender(h, row) {
      return <p class="table-cell-text">{row['createTime'] || '-'}</p>
    }
  },
  {
    label: '操作',
    width: '320',
    fixed: 'right',
    customRender(h, row) {
      return (
        <div class="action-buttons">
          <el-button
            disabled={!this.isShowBtn(this.AUTH_BTN.member_list_add_black)}
            type="danger"
            size="mini"
            icon="el-icon-remove"
            onClick={() => this.addRoster(row['id'], 2)}
            class="action-btn"
          >加黑</el-button>

          <el-button
            disabled={!this.isShowBtn(this.AUTH_BTN.member_list_add_white)}
            type="success"
            size="mini"
            icon="el-icon-check"
            onClick={() => this.addRoster(row['id'], 1)}
            class="action-btn"
          >加白</el-button>

          <el-button
            disabled={!this.isShowBtn(this.AUTH_BTN.member_list_order_remark_list)}
            type="primary"
            size="mini"
            icon="el-icon-edit-outline"
            onClick={() => {
              this.showAddOrEdit = true;
              this.rowId = row['id'];
            }}
            class="action-btn"
          >订单备注</el-button>
        </div>
      )
    }
  }
]
export default {
  name: 'MemberList',
  mixins: [authBtnMixin],
  components:{ OrderRemark },
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        memberName: '',
        mobile: '',
        identityNo: '',
        timeSlot: [],
        leftCreateDate: '',
        rightCreateDate: ''
      },
      rowId: null,
      showAddOrEdit: false,
    }
  },
  provide() {
    return {
      context: this
    }
  },
  activated() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const { memberName, mobile, identityNo, timeSlot } = this.searchData;
      let params = { page: this.currentPage, pageSize: this.pageSize, memberName, mobile, identityNo };
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0] || '';
        params.rightCreateDate = timeSlot[1] || '';
      }
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    // 加入黑/白名单
    addRoster(id, riskLevel) {
      let data = { id, riskLevel };
      this.$confirm(`是否将该用户加入${riskLevel == 2 ? '黑' : '白'}名单, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          addRosterAPI(data).then(() => {
            this.getList();
            this.$message.success('操作成功');
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        })
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
    // 关闭弹框
    closeDialogFun(flag) {
      this.showAddOrEdit = false;
      if (flag) {
        this.getList();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-stats {
    display: flex;
    gap: 24px;
    
    .stat-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      padding: 4px 14px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border-radius: 10px;
      border: 1px solid rgba(64, 158, 255, 0.15);
      
      .stat-label {
        font-size: 12px;
        color: #909399;
        margin-right: 8px;
      }
      
      .stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
      }
    }
  }
}

// 卡片标题样式
.card-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
}

// 搜索卡片样式
.search-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px 28px;
  }

  ::v-deep .el-form {
    &.el-form--inline {
      .el-form-item {
        display: inline-flex;
        align-items: center;
        margin-right: 24px;
        margin-bottom: 16px;
      }
    }

    .el-form-item {
      .el-form-item__label {
        color: #303133;
        font-weight: 600;
        letter-spacing: 0.3px;
        font-size: 14px;
        position: relative;
        
        &::after {
          content: ':';
          margin-left: 2px;
          color: #909399;
        }
      }

      .el-input {
        width: 250px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        .el-input__inner {
          border-radius: 10px;
          height: 38px;
          line-height: 38px;
          border: 1.5px solid #E4E7ED;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background: #fafbfc;
          font-size: 13px;

          &:hover {
            border-color: #C0C4CC;
            background: #ffffff;
          }
        }

        &.is-active .el-input__inner,
        .el-input__inner:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
          background: #ffffff;
        }
      }

      .el-date-editor {
        width: 280px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        .el-range-separator {
          padding: 0 10px;
          color: #606266;
          font-weight: 500;
        }

        .el-range-input {
          width: 35%;
          font-size: 13px;
        }

        .el-input__inner {
          border-radius: 10px;
          height: 38px;
          border: 1.5px solid #E4E7ED;
          background: #fafbfc;
        }
        
        &:hover .el-input__inner {
          border-color: #C0C4CC;
          background: #ffffff;
        }

        &.is-active,
        &:focus-within {
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
          border-radius: 10px;
          
          .el-input__inner {
            background: #ffffff;
          }
        }
      }
    }

    .search-btn {
      border-radius: 10px;
      padding: 10px 24px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      letter-spacing: 0.3px;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      }
    }

    .reset-btn {
      border-radius: 10px;
      padding: 10px 24px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
      border: none;
      box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      letter-spacing: 0.3px;

      &:hover {
        background: linear-gradient(135deg, #909399 0%, #82848a 100%);
        box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }

  ::v-deep .tp-table {
    .el-table {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #EBEEF5;
      background: #ffffff;

      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 700;
        font-size: 14px;
        padding: 18px 0;
        border-bottom: 2px solid #E4E7ED;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        font-size: 12px;
        
        &:first-child {
          padding-left: 20px;
        }
      }

      tbody {
        tr {
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          border-bottom: 1px solid #F0F2F5;

          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 18px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
          }
        }
      }
    }

    .table-cell-text {
      margin: 0;
      color: #606266;
      font-size: 13px;
      line-height: 1.8;
      font-weight: 400;
    }

    .member-name {
      font-weight: 600;
      color: #303133;
      font-size: 14px;
    }

    .status-tag {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 28px;
      line-height: normal;
      border-radius: 6px;
      padding: 0 12px;
      font-weight: 600;
      font-size: 12px;
      letter-spacing: 0.3px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .action-buttons {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;

      .action-btn {
        border-radius: 8px;
        padding: 7px 14px;
        font-size: 12px;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: none;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
        letter-spacing: 0.2px;
        white-space: nowrap;

        &:not(.is-disabled):hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
        }
        
        &:not(.is-disabled):active {
          transform: translateY(0);
        }

        &.el-button--danger {
          background: linear-gradient(135deg, #f78989 0%, #f56c6c 100%);
          box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
          
          &:not(.is-disabled):hover {
            background: linear-gradient(135deg, #f56c6c 0%, #dd6161 100%);
            box-shadow: 0 4px 12px rgba(245, 108, 108, 0.4);
          }
        }

        &.el-button--success {
          background: linear-gradient(135deg, #85ce61 0%, #67c23a 100%);
          box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
          
          &:not(.is-disabled):hover {
            background: linear-gradient(135deg, #67c23a 0%, #5daf34 100%);
            box-shadow: 0 4px 12px rgba(103, 194, 58, 0.4);
          }
        }

        &.el-button--primary {
          background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
          
          &:not(.is-disabled):hover {
            background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
          }
        }

        &.is-disabled {
          opacity: 0.5;
          cursor: not-allowed;
          box-shadow: none;
        }
      }
    }

    .pagination {
      margin-top: 24px;
      padding: 20px 0 0;
      border-top: 2px solid #F0F2F5;
      
      ::v-deep .el-pagination {
        .el-pagination__total {
          color: #606266;
          font-weight: 500;
        }
        
        .btn-prev,
        .btn-next {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #F5F7FA;
            color: #409EFF;
          }
        }
        
        .el-pager li {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            background: #F5F7FA;
          }
          
          &.active {
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            color: #ffffff;
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
          }
        }
        
        .el-select .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
        }
        
        .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .search-card ::v-deep .el-form {
    .el-form-item {
      margin-right: 16px;
    }
  }
  
  .page-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    
    .header-stats {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .search-card,
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
}
</style>
